import type { TypographyOptions } from '@mui/material/styles/createTypography';
import { brand, typography as fonts } from './tokens';

export const typography: TypographyOptions = {
  fontFamily: fonts.fontBody,
  
  // Display - Hero headlines
  h1: {
    fontFamily: fonts.fontDisplay,
    fontSize: '3.5rem',
    fontWeight: 600,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    color: brand.textPrimary,
  },
  
  // Page titles
  h2: {
    fontFamily: fonts.fontDisplay,
    fontSize: '2.5rem',
    fontWeight: 600,
    lineHeight: 1.15,
    letterSpacing: '-0.015em',
    color: brand.textPrimary,
  },
  
  // Section titles
  h3: {
    fontFamily: fonts.fontDisplay,
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
    color: brand.textPrimary,
  },
  
  // Card titles
  h4: {
    fontFamily: fonts.fontBody,
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: brand.textPrimary,
  },
  
  // Subsection titles
  h5: {
    fontFamily: fonts.fontBody,
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.4,
    color: brand.textPrimary,
  },
  
  // Small titles
  h6: {
    fontFamily: fonts.fontBody,
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.4,
    color: brand.textPrimary,
  },
  
  // Lead paragraph
  subtitle1: {
    fontFamily: fonts.fontBody,
    fontSize: '1.125rem',
    fontWeight: 400,
    lineHeight: 1.6,
    color: brand.textSecondary,
  },
  
  // Secondary text
  subtitle2: {
    fontFamily: fonts.fontBody,
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
    color: brand.textSecondary,
  },
  
  // Body text
  body1: {
    fontFamily: fonts.fontBody,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.6,
    color: brand.textSecondary,
  },
  
  // Small body text
  body2: {
    fontFamily: fonts.fontBody,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: brand.textMuted,
  },
  
  // Buttons
  button: {
    fontFamily: fonts.fontBody,
    fontSize: '0.9375rem',
    fontWeight: 600,
    textTransform: 'none',
    letterSpacing: '0.01em',
  },
  
  // Captions
  caption: {
    fontFamily: fonts.fontBody,
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: brand.textMuted,
  },
  
  // Labels / Overlines
  overline: {
    fontFamily: fonts.fontBody,
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: brand.blue600,
  },
};
